/**
 * JsonEditor - Simple JSON editor with validation
 * 
 * CHANGE HISTORY:
 * - 251201_0515 danielbeer: Created simple JSON editor for FileMaker parameters
 * 
 * TODO: Replace with full Editr integration when available
 */

import React, { useState, useEffect } from 'react';
import './JsonEditor.css';

export interface JsonEditorProps {
  value: Record<string, any>;
  onChange: (value: Record<string, any>) => void;
  placeholder?: string;
  rows?: number;
}

export function JsonEditor({
  value,
  onChange,
  placeholder = '{}',
  rows = 8
}: JsonEditorProps) {
  const [text, setText] = useState(JSON.stringify(value, null, 2));
  const [error, setError] = useState<string | null>(null);

  // Update text when value changes externally
  useEffect(() => {
    setText(JSON.stringify(value, null, 2));
  }, [value]);

  const handleChange = (newText: string) => {
    setText(newText);
    
    try {
      const parsed = JSON.parse(newText);
      setError(null);
      onChange(parsed);
    } catch (err) {
      setError((err as Error).message);
      // Don't call onChange if invalid JSON
    }
  };

  return (
    <div className="json-editor">
      <textarea
        value={text}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={error ? 'json-editor-textarea error' : 'json-editor-textarea'}
        spellCheck={false}
      />
      {error && (
        <div className="json-editor-error">
          ⚠️ Invalid JSON: {error}
        </div>
      )}
    </div>
  );
}
